import React, { ReactNode } from 'react';
import { getContext } from '@fiverr-private/fiverr_context';
import { ExternalLink } from './ExternalLink';

interface AffiliatesLinkProps {
  path: string;
  type?: 'button' | 'link';
  clickText?: string;
  category?: string;
  children: ReactNode;
  variant?: 'footer' | 'header' | 'subitem';
}

export const AffiliatesLink = ({ path, type, clickText, category, children, variant }: AffiliatesLinkProps) => (
  <ExternalLink variant={variant} type={type} clickText={clickText} href={getTo(path)} category={category}>
    {children}
  </ExternalLink>
);

const getTo = (path: string) => {
  const { locale } = getContext();

  return `https://affiliates.fiverr.com${getLanguagePath(locale)}${path}`;
};

const getLanguagePath = (locale: string) => {
  switch (locale) {
    case 'en-US':
      return '';
    case 'pt-BR':
      return '/pt-br';
    default:
      return `/${locale.substr(0, 2)}`;
  }
};
